import Toast from '@/components/Toast';
import React from 'react';
import { useNotification } from '../hooks/useNotification';
import { NotificationType } from '@/context/types/Notification';

const NotificationToasts: React.FC<React.HTMLProps<HTMLDivElement>> = () => {
  const { openToast, handleCloseToast } = useNotification();

  switch (openToast?.type) {
    case NotificationType.BATCH_DELETED:
    case NotificationType.CREATE_BATCH_SUCCESS:
      return (
        <>
          <Toast size="sm" isOpen={openToast != undefined} variant={openToast?.variant}>
            <div className="flex flex-col gap-y-2">
              {openToast?.title ? (
                <div className="text-md font-semibold">{openToast?.title}</div>
              ) : null}
              <div className="font-normal">{openToast?.description ?? ''}</div>
            </div>
          </Toast>
        </>
      );
    case NotificationType.BATCH_PAYMENT_COMPLETE:
    case NotificationType.BATCH_PAYMENT_INCOMPLETE:
      return (
        <>
          <Toast
            isOpen={openToast != undefined}
            onClose={handleCloseToast}
            variant={openToast?.variant}>
            <div className="flex flex-col gap-y-3">
              {openToast?.title ? (
                <div className="text-base font-medium leading-6 pr-6">{openToast?.title}</div>
              ) : null}
              <div className="text-sm font-normal leading-5">{openToast?.description ?? ''}</div>
            </div>
          </Toast>
        </>
      );
    default:
      return (
        <>
          <Toast
            isOpen={openToast != undefined}
            onClose={handleCloseToast}
            variant={openToast?.variant}>
            <div className="flex flex-col gap-y-2">
              {openToast?.title ? (
                <div className="text-md font-semibold">{openToast?.title}</div>
              ) : null}
              <div className="font-normal">{openToast?.description ?? ''}</div>
            </div>
          </Toast>
        </>
      );
  }
};

export default NotificationToasts;
